import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1319.1 790.054 1020.06 355.79C986.895 307.625 932.507 308.517 899.956 355.79L600.92 790.054C567.754 838.219 588.339 877.264 647.036 877.264H1272.98C1331.62 877.264 1351.65 837.326 1319.1 790.054zM600.634 1129.94 899.669 1564.21C932.836 1612.37 987.223 1611.48 1019.77 1564.21L1318.81 1129.94C1351.98 1081.78 1331.39 1042.73 1272.69 1042.73L646.75 1042.73C588.114 1042.73 568.082 1082.67 600.634 1129.94z"
});

var IconMiniArrowDoubleLine = /*#__PURE__*/function (_Component) {
  _inherits(IconMiniArrowDoubleLine, _Component);

  var _super = _createSuper(IconMiniArrowDoubleLine);

  function IconMiniArrowDoubleLine() {
    _classCallCheck(this, IconMiniArrowDoubleLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconMiniArrowDoubleLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMiniArrowDouble",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMiniArrowDoubleLine.displayName = "IconMiniArrowDoubleLine";
  return IconMiniArrowDoubleLine;
}(Component);

IconMiniArrowDoubleLine.glyphName = 'mini-arrow-double';
IconMiniArrowDoubleLine.variant = 'Line';
IconMiniArrowDoubleLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMiniArrowDoubleLine;
export { IconMiniArrowDoubleLine };